/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import NFTs from "../ranking.json";
import nft from "./nft.json";
import React, { useState, useEffect } from "react";
import { walletOfOwner } from "../utils/interact";
import axios from "axios";
import { saveAs } from "file-saver";
function Index() {
  // console.log(nft.length);

  const [List, setList] = useState(nft.sort((a, b) => a.token_id - b.token_id));
  console.log(List.slice(120, 170));
  function arrayObjectIndexOf() {
    List.slice(0, 100);
    // List.map((item, i) => {
    //   // console.log(item);
    //   if (item.metadata !== null) {
    //     const imageUrl = `https://ipfs.io/ipfs/${
    //       JSON.parse(item.metadata).image.split("//")[1]
    //     }`;
    //     return (
    //       <div key={i}>
    //         <img src={imageUrl} alt="" />
    //         <a href={imageUrl} download>
    //           Download
    //         </a>
    //       </div>
    //     );
    //   }
    // });
    return null;
  }

  const saveFile = (url, name) => {
    saveAs(url, name);
  };

  // useEffect(() => {
  //   arrayObjectIndexOf();
  // }, []);

  // function arrayObjectIndexOf(myArray, property, searchTerm) {
  //   for (var i = 0, len = myArray.length; i < len; i++) {
  //     if (myArray[i][property] === parseInt(searchTerm)) {
  //       return (
  //         <div className="swaggo" data-sort="a" key={i}>
  //           <img
  //             src={`https://ipfs.io/ipfs/QmRNJJbYRabSHYxBpR5bwXC52DDwd9Bs5pCnnLTgaj9AJG/${searchTerm}.png`}
  //             alt=""
  //           />
  //           <p className="swaggo_name">
  //             Classic Swaggo Rank #{myArray[i]["Rarity"]}
  //           </p>
  //           <p className="swaggo_rank">Token ID #{searchTerm}</p>
  //           <p className="swaggo_owner"></p>
  //         </div>
  //       );
  //     }
  //   }
  //   return null;
  // }

  // useEffect(async () => {
  //   call();
  // }, []);
  // const call = async () => {
  //   axios.defaults.headers.common = {
  //     "X-API-Key":
  //       "vBbLWHRePzZYdZnznRwHCrFXCSbznafOMD5uPd7DdYcMuwdpXK7njFHFII2hN5Fa",
  //   };
  //   const list = [];
  //   let cursor = "";
  //   for (let step = 0; step < 40; step++) {
  //     if (step === 0) {
  //       await axios
  //         .get(
  //           "https://deep-index.moralis.io/api/v2/nft/0xf61f24c2d93bf2de187546b14425bf631f28d6dc?chain=eth&format=decimal"
  //         )
  //         .then((response) => {
  //           cursor = response.data.cursor;
  //           console.log(response.data.page);
  //           list.push(response.data.result);
  //         });
  //     } else {
  //       await axios
  //         .get(
  //           `https://deep-index.moralis.io/api/v2/nft/0xf61f24c2d93bf2de187546b14425bf631f28d6dc?chain=eth&format=decimal&cursor=${cursor}`
  //         )
  //         .then((response) => {
  //           cursor = response.data.cursor;
  //           console.log(response.data.page);
  //           list.push(response.data.result);
  //         });
  //     }
  //     console.log(list);
  //   }
  // };

  // const [List, setList] = useState(NFTs);
  // const [token, setToken] = useState([]);

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // useEffect(async () => {
  //   const token = await walletOfOwner();
  //   setToken(token);
  // }, []);

  // function arrayObjectIndexOf(myArray, property, searchTerm) {
  //   for (var i = 0, len = myArray.length; i < len; i++) {
  //     if (myArray[i][property] === parseInt(searchTerm)) {
  //       return (
  //         <div className="swaggo" data-sort="a" key={i}>
  //           <img
  //             src={`https://ipfs.io/ipfs/QmRNJJbYRabSHYxBpR5bwXC52DDwd9Bs5pCnnLTgaj9AJG/${searchTerm}.png`}
  //             alt=""
  //           />
  //           <p className="swaggo_name">
  //             Classic Swaggo Rank #{myArray[i]["Rarity"]}
  //           </p>
  //           <p className="swaggo_rank">Token ID #{searchTerm}</p>
  //           <p className="swaggo_owner"></p>
  //         </div>
  //       );
  //     }
  //   }
  //   return null;
  // }

  return <section className="no_side_space mp_up"></section>;
}

export default Index;
// {
//   // return
//   // arrayObjectIndexOf()
//   List.map((item, i) => {
//     // console.log(item);
//     if (item.metadata !== null) {
//       const imageUrl = `https://ipfs.io/ipfs/${
//         JSON.parse(item.metadata).image.split("//")[1]
//       }`;
//       return (
//         <div key={i}>
//           <a onClick={saveFile(imageUrl, `${item.token_id}.png`)}>
//             Donload #{item.token_id}
//           </a>
//           {/* <a
//                   href={imageUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   download
//                 >
//                   Download
//                 </a> */}
//         </div>
//       );
//     }
//   });
// }
